import { useProductConsumerScansInfo } from 'src/hooks/fetch/use-products-consumer-scans-info.hook';
import { Loader } from 'src/components';

import { Box, Typography, useTheme } from '@mui/material';
import { ConsumerScansLocationsMap } from './map.component';
import { AIVerifiedBannerAll } from '../ai-verified-banner/ai-verified-banner-all';

interface IProps {
  productId: string;
}

export const ConsumerScansLocations = ({ productId }: IProps) => {
  const theme = useTheme();
  const { data, isLoading } = useProductConsumerScansInfo(productId);

  if (isLoading) {
    return <Loader />;
  }

  if (!data || data.coordsArray?.length === 0) {
    return null;
  }

  const scansCount = Math.max(data?.coordsArray?.length, data?.transactionsData?.length);

  return (
    <Box id="index__components-consumer-scans-locations__box__l27"
    sx={{
      boxSizing: 'border-box',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      p: '15px  30px',
      gap: '16px'
    }}>
      
      <Typography id="index__components-consumer-scans-locations__typography__l39"
      fontSize={'14px'}
      fontWeight={600}
      sx={{ boxSizing: 'border-box', width: '100%' }}>
        
        Locations of all scans
      </Typography>
      <Box id="index__components-consumer-scans-locations__box__l46"
      sx={{
        boxSizing: 'border-box',
        width: '100%',
        height: '400px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        
        <ConsumerScansLocationsMap data={data?.coordsArray || []} />
      </Box>

      <Box id="index__components-consumer-scans-locations__box__l59"
      sx={{
        boxSizing: 'border-box',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
        gap: '10px'
      }}>
        
        <Typography id="index__components-consumer-scans-locations__typography__l69"
        fontSize={'12px'}
        sx={{ boxSizing: 'border-box', color: theme.palette.grey[500], maxWidth: '250px' }}>
          
          {`This item has been scanned and verified by consumers ${scansCount} times`}
        </Typography>

        <AIVerifiedBannerAll
          data={data?.transactionsData || []}
          aiVerifiedCount={data?.transactionsData?.length} />
        
      </Box>
    </Box>);

};